<template>
    <div class="loginbg" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                Logout from (<a v-bind:href="ssoDomainUrl">{{ssoDomainUrl}}</a>),If You are not able to login please clear Cookies and login again.
                                Please contact admin if you are still not able to Login.
                            </label>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Vue from 'vue';
    import EventBus from './event-bus.js';
    import {HTTP} from '../http-common';
    import {commonMixins} from '../mixins/commonMixins';

    export default {
        name: 'Login',
        mixins: [commonMixins],
        data() {
            return {
                username: "",
                password: "",
                login_err_msg: "",
                forgot_pass_url: "",
                remember_me: true,
                /* sign_up_url: "", */
                forgot_pass_url: "",
                register_url: "",
                username_error_msg: "",
                password_error_msg: "",
                ssoDomainUrl : "",
            }
        },
        created: function () {

        },
        beforeMount: function () {
            console.log("Before Mount");
            self = this;
            self.ssoDomainUrl = process.env.SSO_ROOT_URL;
            console.log(self.ssoDomainUrl);
            console.log(self.$route.query);
            
            if(self.$route.query.redirect == "false") {
                // DO NOTHING
            } else {
                if(self.$route.query.token) {
                    window.localStorage.setItem("access_token", self.$route.query.token);
                    window.localStorage.setItem("username", self.$route.query.username);
                    self.autoLoginUser(self.$route.query.username);
                } else {
                    var api_token = localStorage.getItem("access_token");
                    if(api_token == null) {
                        $(".loginbg").show();
                        window.location.href = process.env.SSO_ROOT_URL + "/login?redirect=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                    } else {
                        self.getFirstMenu();
                    }
                }
            }
        },
        mounted: function () {
            /* var self = this;
            self.username = self.getCookie('sales_username');
            self.password = self.getCookie('sales_password');
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                self.getFirstMenu();
            } else {
                $(".loginbg").show();
            }
            $(document).ready(function () {
                $('#rememberMe').change(function () {
                    if (this.checked) {
                        self.remember_me = true;
                    } else {
                        self.remember_me = false;
                    }
                });
            });
            self.forgot_pass_url = process.env.HR_URL + "?identify=" + window.location.href; */
            /* self.sign_up_url = process.env.HR_SIGNUP_URL + "?identify=" + window.location.href; */
        },
        methods: {
            setCookie: function (cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },
            getCookie: function (cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            },
            getFirstMenu: function () {
                var self = this;
                HTTP.get("get_first_menu", [])
                        .then(function (response) {
                            if (response.data.code == 200) {
                                //console.log(JSON.stringify(response.data.content.slug));
                                window.location.href = "/" + response.data.content.slug;
                            }
                        })
                        .catch(function (err) {
                            //console.log(err);
                            self.catchHandler(err, function () {

                            });
                        });
            },
            autoLoginUser: function (username) {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("access_token")}
                };
                var fields = {
                    'username': username,
                    'access_token': window.localStorage.getItem('access_token')
                };
                HTTP.post("autologinuser", fields)
                    .then(function (data) {
                        if (data.status == 200) {
                            /* Build version checking start*/
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.data.content.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.data.content.build);
                            } else if(current_build != latest_build){
                                localStorage.setItem("build_version", data.data.content.build);
                                console.info("New Build Version " + latest_build);
                                location.reload(true);
                            }
                            /* Build version checking end*/
                            localStorage.setItem("user_role", data.data.content.role.roles.id);
                            localStorage.setItem("tkn", data.data.content.api_token);
                            localStorage.setItem("user_obj", JSON.stringify(data.data.content.user));
                            EventBus.$emit('logged-in', true,
                                data.data.content.user["first_name"],
                                data.data.content.user["last_name"],
                                data.data.content.user["username"],
                                data.data.content.user["username"],
                            );
                            window.location.href = "/" + data.data.content.menu.slug;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.login_err_msg = error.response.data.message;
                    })
            },
            login: function () {
                //debugger
                var self = this;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        $('#loginbtn').text("Login...");
                        $("#loginbtn").attr("disable", true);
                        var fields = {
                            username: self.username,
                            password: self.password
                        };
                        HTTP.post("login", fields)
                                .then(function (data) {
                                    $('#loginbtn').text("Login");
                                    $("#loginbtn").attr("disable", false);
                                    if (data.status == 200) {
                                        localStorage.setItem("user_role", data.data.content.role.roles.id);
                                        localStorage.setItem("tkn", data.data.content.user.api_token);
                                        localStorage.setItem("user_obj", JSON.stringify(data.data.content.user));
                                        EventBus.$emit('logged-in', true, data.data.content.user.first_name, data.data.content.user.last_name, data.data.content.user.username);
                                        if (self.remember_me) {
                                            /*self.setCookie('vvg_sso_auth_token', response.data.content.api_token, 365);*/
                                            self.setCookie('sales_username', self.username, 365);
                                            self.setCookie('sales_password', self.password, 365);
                                        } else {
                                            self.setCookie('sales_username', '', 365);
                                            self.setCookie('sales_password', '', 365);
                                        }
                                        /* $.cookie('username', self.username, {expires: 365});
                                        $.cookie('password', self.password, {expires: 365}); */
                                        window.location.href = "/" + data.data.content.menu.slug;
                                    }
                                    /* if (data.status == 201) {
                                        self.server_name = data.data.content.user.name;
                                        self.server_address = data.data.content.user.address;
                                        self.server_email = data.data.content.user.email;
                                        self.server_pass = data.data.content.user.password;
                                        self.server_mobile = data.data.content.user.mobileno;
                                    } */
                                })
                                .catch(function (error) {
                                    $('#loginbtn').text("Login");
                                    $("#loginbtn").attr("disable", false);
                                    //console.log(error);
                                    self.login_err_msg = error.response.data.message;
                                })
                        return;
                    }
                });
            }
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Login.vue